import axios from "axios";

export default {
    GetData(context, advancedQueryCriteria) {
        let postData = {};
        if (advancedQueryCriteria.Realtional !== null || advancedQueryCriteria.MrAttributes !== null) {
            postData = advancedQueryCriteria;
        }

        return axios({
            // TODO: switch to ci endpoint
            url: `${process.env.VUE_APP_API_URL}/ci/data/${context.type}/${context.id}`,
            method: "POST",
            data: postData,
        });
    },
    GetNationalData(advancedQueryCriteria) {
        return axios({
            // TODO: switch to ci endpoint
            url: `${process.env.VUE_APP_API_URL}/ci/nationalData`,
            method: "POST",
            data: advancedQueryCriteria,
        });
    },
    GetMrAttributes() {
        // TODO: switch to ci endpoint
        return axios.get(`${process.env.VUE_APP_API_URL}/ci/retrieveIndexedMrAttributes`);
    },
};
